<template>
  <div ref="scrollContainer" class="terms-container-v2 s-pb-4 tnc-container">
    <component
      ref="termsComponent"
      :is="getPayfacComponent()"
      :on-cancel="onCancel"
      :loading="loading"
      :onboard-merchant="onboardMerchant"
      :close-popup="closePopup"
    />
    <!-- sentinel at the end to detect scroll-to-bottom -->
    <div ref="bottomSentinel" class="tnc-sentinel"></div>
  </div>
</template>
<script>


import {submitOnboardingMerchant} from "@/service/merchantService";
import {mapActions, mapGetters} from "vuex";
import {navigateTo} from "@/router";
import {callbackApplicationAjax} from "@/app/utils/common/functions/functions";
import {storeErrorDetails} from "@/service/saveInStore";
import FullStoryHelper from '@/app/utils/fullstory';
import {
  MERCHANT_ONBOARD_SUBMIT,
  MERCHANT_CREATED_SUCCESS,
  MERCHANT_CREATED_FAILED,
} from "@/app/utils/fullstory/constants";
import FinixTermsAndConditions from "@/components/onboarding/termsAndConditions/FinixTermsAndConditions";
import AdyenTermsAndConditionsV2 from "@/components/onboarding/termsAndConditions/AdyenTermsAndConditionsV2";
import {RouteConstants} from "@/router/routeConstants";
import {TermsAndConditions} from "@/app/utils/common/constants";
import {PayfacType} from "@/api/paymentApi";

export default {
  name: "TermsAndConditionsV2",
  components: {AdyenTermsAndConditionsV2, FinixTermsAndConditions},
  props: {
    onCancel: {
      type: Function,
      required: true
    },
  },
  emits: ['read-to-end'],
  data: function () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('app', ['getCallbackUrl', 'getDraftMerchantId', "getSessionPayfac"]),
    ...mapGetters('merchantPayfacDetails', ['getOnboardingStep']),
  },
  mounted() {
    // find the modal's scrollable container
    const modalBody = document.querySelector('.s-modal-body') || document.documentElement;
    let emitted = false;

    // handler to check if scrolled to bottom and emit once
    this._onScroll = () => {
      if (modalBody.scrollTop + modalBody.clientHeight >= modalBody.scrollHeight - 5) {
        if (!emitted) {
          emitted = true;
          this.$emit('read-to-end');
          modalBody.removeEventListener('scroll', this._onScroll);
        }
      }
    };

    // listen for scroll events
    modalBody.addEventListener('scroll', this._onScroll);
    // initial check for non-scrollable content
    this._onScroll();
  },
  beforeUnmount() {
    const modalBody = document.querySelector('.s-modal-body') || document.documentElement;
    if (this._onScroll) modalBody.removeEventListener('scroll', this._onScroll);
  },
  methods: {
    ...mapActions('app', ['updateAppState']),
    ...mapActions('agreementAcceptance', ['acceptAgreement']),
    ...mapActions('merchantPayfacDetails', ['setOnboardingStatus']),
    getPayfacComponent() {
      return this.getSessionPayfac === PayfacType.FINIX ? TermsAndConditions.FINIX : TermsAndConditions.ADYEN_V2;
    },
    onboardMerchant() {
      // Check if recurring charges consent is accepted for Adyen components
      if (this.$refs.termsComponent && this.$refs.termsComponent.recurringChargesConsentAccepted !== undefined) {
        if (!this.$refs.termsComponent.recurringChargesConsentAccepted) {
          this.$warning(this.$t('termsAndCharges.recurringChargesConsentRequired') || 'Please accept the recurring charges consent to proceed.');
          return;
        }
      }
      
      this.loading = true;
      FullStoryHelper.event(MERCHANT_ONBOARD_SUBMIT)
      submitOnboardingMerchant().then(response => {
        this.loading = false;
        this.setOnboardingStatus({"payfac": this.getSessionPayfac, "provisioningStatus": "PROVISIONING"});
        FullStoryHelper.event(MERCHANT_CREATED_SUCCESS)
        this.updateAppState({key: 'merchantId', value: response.id});
        callbackApplicationAjax(this.getCallbackUrl, response.id,
          this.getDraftMerchantId, this.getOnboardingStep(this.getSessionPayfac));
        navigateTo(RouteConstants.ONBOARDING_SUCCESS);
      }).catch(err => {
        this.loading = false;
        storeErrorDetails(err);
        let errorMsg = err.source?.detail;
        if (err.source?.sub_errors) {
          errorMsg = err.source.sub_errors[0]?.message;
        } else if (errorMsg) {
          const errorIndex = errorMsg.indexOf("Error");
          if (errorIndex !== -1) {
            errorMsg = errorMsg.substring(errorIndex);
          }
        }
        this.$danger(this.$t('errors.submitOnboardingFailed') + " - " + errorMsg,
            {dismissable: true, timeout: 20000});
        this.closePopup();
        FullStoryHelper.event(MERCHANT_CREATED_FAILED )
      })
    },
    closePopup() {
      this.onCancel();
    }
  }
}
</script>

<style lang="scss">
.tnc-container {
  overflow: visible !important;
  max-height: none !important;
}
.tnc-sentinel {
  height: 1px;
}

.terms-container-v2 {
  padding: 2px;
  font-size: 14px;


  & .header {
    display: flex;
    justify-content: start;
    position: sticky;
    color: $text-color;
    top: 0;
    padding-top: 30px;
    background-color: $color-white;
    z-index: 99;

    & .title-container {
      text-align: left;

      & .title {
        font-size: 24px;
        font-weight: $weight_bold;
        color: $text-color;
        margin-bottom: 8px;
      }

      & .subtitle {
        font-size: 12px;
        color: $subtitle_text;
      }
    }
  }

}


</style>
